// extracted by mini-css-extract-plugin
export var avatarContainer = "_i1-0";
export var avatarTypingWave = "_i1-i";
export var gray = "_i1-f";
export var green = "_i1-c";
export var icon = "_i1-9";
export var image = "_i1-1";
export var lg = "_i1-6";
export var md = "_i1-5";
export var presenceDot = "_i1-b";
export var red = "_i1-d";
export var sm = "_i1-4";
export var status = "_i1-a";
export var typingDot = "_i1-h";
export var typingPill = "_i1-g";
export var xl = "_i1-7";
export var xs = "_i1-3";
export var xxl = "_i1-8";
export var xxs = "_i1-2";
export var yellow = "_i1-e";